import { combineReducers } from "redux"

import all from "./all/slice"

const measurementReducer = combineReducers({
  all,
})

export default measurementReducer
